import { useTranslation } from 'react-i18next'

export type StringTranslate = (fullKey: string, options?: Record<string, unknown>) => string

export const useStringTranslation = (namespace = 'core'): StringTranslate => {
  const { t } = useTranslation(namespace)
  return (fullKey, options) => String(t(fullKey, options))
}
